<template>
  <div>
    <b-modal v-model="modalActive" width="90%" scroll="keep">
      <div class="card">
        <header class="card-header ">
          <div class="card-header-title is-flex">
            <h6 class="is-size-6 ml-auto mr-auto pl-4 has-text-weight-semibold">{{ title }}</h6>
          </div>
          <b-button class="card-header-icon mt-2 mr-2" aria-label="more options" @click="show(false, false, false)">
            <b-icon icon="close"></b-icon>
          </b-button>
        </header>
        <div class="card-content" :style="isChooseModelEditOrAddAllowed(data) ? 'height:600px' : 'height: 300px'">
          <div class="content" v-if="data">

            <div class="m-0 p-0 pr-2 pl-0">
              <div class="is-size-7 has-text-grey-light mt-1">Site Name</div>
              <div class="mt-0 has-text-weight-semibold">{{ data.siteName }}</div>
            </div>

            <div class="m-0 p-0 pr-2 pl-0">
              <div class="is-size-7 has-text-grey-light mt-1">Device Name</div>
              <div class="mt-0 has-text-weight-semibold">{{ data.name }}</div>
            </div>

            <div class="mt-3 mb-6">
              <div class="m-0 p-0 pr-0 pl-0">
                <div class="is-size-7 has-text-grey-light mt-1">AI Model Settings</div>
                <div>
                  <div v-if="currentModel" class="columns m-0 p-0">
                    <div class="column p-0 m-0">
                      <div class="is-size-7">Function name:</div>
                      <div class="has-text-weight-semibold">{{ currentModel.functionName }}</div>
                    </div>
                    <div class="column p-0 m-0 ml-3">
                      <div class="is-size-7">Selected model:</div>
                      <div class="has-text-weight-semibold">{{ currentModel.modelName }}</div>
                    </div>
                    <div class="column p-0 m-0 ml-3">
                      <div class="is-size-7">Desired classes:</div>
                      <div class="has-text-weight-semibold">{{ currentModel.classes.toString() }}</div>
                    </div>
                    <div class="column p-0 m-0 ml-3">
                      <div class="is-size-7">Batch size:</div>
                      <div class="has-text-weight-semibold">{{ currentModel.batchSize }}</div>
                    </div>
                    <div class="column p-0 m-0 ml-3">
                      <div class="is-size-7">Skip frame:</div>
                      <div class="has-text-weight-semibold">{{ currentModel.skipFrame }}</div>
                    </div>
                    <div class="column p-0 m-0 ml-3">
                      <div class="is-size-7">Conf level:</div>
                      <div class="has-text-weight-semibold">{{ currentModel.confLevel }}</div>
                    </div>
                  </div>
                  <div v-else class="is-size-6 has-text-weight-normal has-text-warning">Model is not defined</div>
                </div>
                <div v-if="isChooseModelEditOrAddAllowed(data)">
                  <div class="mt-6">Edit AI Model Settings</div>
                  <div class="columns m-0 p-0 is-align-items-center mt-3">
                    <div class="column p-0 is-2">
                      <b-field label="Tracking Type" label-position="on-border" expanded>
                        <b-select placeholder="Select Tracking Type..." v-model="selectedTracking"
                                  @input="onTrackingSelectionChanged" required expanded>
                          <option
                              v-for="option in trackingOptions()"
                              :value="option"
                              :key="option">
                            {{ option }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                    <div class="column p-0 is-2 ml-3">
                      <b-field label="Model" label-position="on-border" expanded>
                        <b-select placeholder="Select Model..." v-model="selectedModel" @input="onModelSelectionChanged" required expanded>
                          <option
                              v-for="option in modelOptions()"
                              :value="option"
                              :key="option">
                            {{ option }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                    <div class="column p-0 is-2 ml-3">
                      <b-field label="Model version" label-position="on-border" expanded>
                        <b-select placeholder="Select Model version..." v-model="selectedVersion" @input="onVersionSelectionChanged" required expanded>
                          <option
                              v-for="option in versionOptions()"
                              :value="option"
                              :key="option">
                            {{ option }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                  </div>
                  <div v-if="advancedSettingsAvailable()">
                    <div class="mt-3 is-size-7">Advanced Settings</div>
                    <div class="columns m-0 p-0 is-align-items-center mt-3">
                      <div class="column p-0 is-2" v-if="advancedSettingsAvailable()">
                        <b-field label="Batch size" label-position="on-border">
                          <b-input placeholder="Set Batch Size" v-model.number="advancedSettings.batchSize"
                                   type="number"></b-input>
                        </b-field>
                      </div>
                      <div class="column p-0 is-2 ml-2" v-if="advancedSettingsAvailable()">
                        <b-field label="Conf Level" label-position="on-border">
                          <b-input placeholder="Set Conf Level" v-model.number="advancedSettings.confLevel"
                                   type="number" step=".01"></b-input>
                        </b-field>
                      </div>
                      <div class="column p-0 is-2 ml-3" v-if="advancedSettingsAvailable()">
                        <b-checkbox class="ml-3" v-model="advancedSettings.skipFrame">
                          Skip Frame
                        </b-checkbox>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <footer class="card-footer" v-if="isChooseModelEditOrAddAllowed(data)">
          <b-button class="is-primary is-fullwidth m-2" @click="onSaveClicked" rounded :disabled="!canSave()">Create
            Tasks
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {isChooseModelEditOrAddAllowed,} from "@/utils/helper";

export default {
  name: "choose-ai-model-modal",
  components: {},
  data() {
    return {
      isLoading: false,
      modalActive: false,
      data: null,
      title: null,
      infoType: null,
      processingPeriods: [],
      desiredClassesOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      models: [
        {name: "Path Tracking Ped Only", modelName: "yolo11m.pt", functionName: "video_object_path_tracking_ped_only"},
        {name: "Path Tracking Dtp", modelName: "LyraV3.pt", functionName: "video_object_path_tracking_dtp"},
        {
          name: "Traffic Light Detection",
          modelName: "traffic-lightv1.pt",
          functionName: "video_traffic_light_detection"
        },
        {name: "Path Tracking", modelName: "LyraV2.2.pt", functionName: "video_path_tracking"},
        {
          name: "Moto Bike",
          modelName: "LyraV2_motorbike.pt",
          functionName: "video_object_path_tracking_motorcycle"
        }
      ],
      currentModel: null,
      newModel: {
        functionName: null,
        modelName: null,
        classes: [],
        confLevel: null,
        removePolyPoints: [],
        skipFrame: false,
        batchSize: null,
        advancedSettings: false
      },
      advancedSettings:{
        confLevel: 0.1,
        removePolyPoints: [],
        skipFrame: true,
        batchSize: 20.0,
      },
      selectedTracking: null,
      selectedModel: null,
      selectedVersion: null,
      modelsStructure: {
        'Path Tracking': {
          'Lyra': {
            'Lira V3': {
              functionName: "video_object_path_tracking_lyra",
              modelName: "LyraV3.pt",
              classes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
              hasAdvancedSettings: true
            },
          },
          'Yolo': {
            'Yolo 11m': {
              function_name: "video_object_path_tracking_yolo",
              tracking_model: "yolov11m.pt",
              desired_classes: [0, 1, 2, 3, 4, 5, 6, 7],
              hasAdvancedSettings: true
            },
            'Yolo 9c': {
              function_name: "video_object_path_tracking_yolo",
              tracking_model: "yolov9c.pt",
              desired_classes: [0, 1, 2, 3, 4, 5, 6, 7],
              hasAdvancedSettings: true
            }
          },
          'Motorcycle': {
            'Lyra 2 Moto bike': {
              function_name: "video_object_path_tracking_motorcycle",
            }
          }
        },
        'Light Tracking': {
          'Traffic Light': {
            'Light Detection': {
              function_name: "video_traffic_light_detection",
            }
          }
        }
      }
    }
  },
  mounted() {
    this.processingPeriods = []
  },
  methods: {
    isChooseModelEditOrAddAllowed,
    show(show, data, title) {
      console.log('On show choose modal data: ', data)
      this.processingPeriods = []
      this.data = data
      this.title = title
      this.currentModel = this.data && this.data.tasks && this.data.tasks.model ? this.data.tasks.model : null
      if (this.currentModel) {
        //TODO Find selected values
/*        this.newModel = JSON.parse(JSON.stringify(this.currentModel))
        this.newModel.advancedSettings = false*/
      } else {
        this.selectedTracking = null
        this.selectedModel = null
        this.selectedVersion = null
        this.advancedSettings = {
          confLevel: 0.1,
          removePolyPoints: [],
          skipFrame: true,
          batchSize: 20.0,
        }
      }
      this.modalActive = show

      console.log('New model: ', this.newModel)
    },
    trackingOptions() {
      return Object.keys(this.modelsStructure)
    },
    modelOptions() {
      if (this.selectedTracking) {
        return Object.keys(this.modelsStructure[this.selectedTracking])
      }
      return []
    },
    versionOptions() {
      if (this.selectedTracking && this.selectedModel) {
        return Object.keys(this.modelsStructure[this.selectedTracking][this.selectedModel])
      }
      return []
    },
    advancedSettingsAvailable() {
      if (this.selectedTracking && this.selectedModel && this.selectedVersion) {
        if(this.modelsStructure[this.selectedTracking][this.selectedModel][this.selectedVersion].hasAdvancedSettings){
          return true
        }
      }
      return false
    },
    onTrackingSelectionChanged(newModelName) {
      this.selectedModel = null
      this.selectedVersion = null
    },
    onModelSelectionChanged(newModelName) {
      this.selectedVersion = null
    },
    onVersionSelectionChanged(newModelName) {

    },
    onSaveClicked() {
      console.log('On update current model', this.newModel)
      if (this.selectedTracking && this.selectedModel && this.selectedVersion) {
        let newModel = JSON.parse(JSON.stringify(this.modelsStructure[this.selectedTracking][this.selectedModel][this.selectedVersion]))
        if(this.advancedSettingsAvailable()){
          const mergedObj = { ...newModel, ...this.advancedSettings };
          this.$emit('onSaveModel', {dataDeviceId: this.data._id, model: mergedObj})
        }else{
          this.$emit('onSaveModel', {dataDeviceId: this.data._id, model: newModel})
        }
      }

    },
    canSave() {
      return (this.selectedTracking && this.selectedModel && this.selectedVersion);
    }
  }
}
</script>

<style scoped lang="scss">
</style>